export default {
  REGIONAL_HOME_PATH: (city_slug = ':city_slug') => `/${city_slug}`,
  REGIONAL_CONTACTS_PATH: (city_slug = ':city_slug') => `/${city_slug}/contacts`,
  REGIONAL_CATALOGUE_PATH: (city_slug = ':city_slug') => `/${city_slug}/tovary`,
  REGIONAL_RUBRIC_PATH: (city_slug = ':city_slug', rubric_path = '*', params = null) => `/${city_slug}/tovary/${rubric_path}${params ? `?${params}` : ''}`,
  REGIONAL_PRODUCT_PATH: (city_slug = ':city_slug', rubric_path = '*', id = ':id') => `/${city_slug}/tovary/${rubric_path}/${id}`,

  REGIONAL_BRAND_PATH: (city_slug = ':city_slug', id = ':id') => `/${city_slug}/brands/${id}`,
  REGIONAL_BRANDS_PATH: (city_slug = ':city_slug', id = ':id') => `/${city_slug}/brands`,

  REGIONAL_STOCK_PATH: (city_slug = ':city_slug', id = ':id') => `/${city_slug}/stocks/${id}`,
  REGIONAL_STOCKS_PATH: (city_slug = ':city_slug') => `/${city_slug}/stocks`,

  REGIONAL_ARTICLE_PATH: (city_slug = ':city_slug', id = ':id') => `/${city_slug}/articles/${id}`,
  REGIONAL_ARTICLES_PATH: (city_slug = ':city_slug') => `/${city_slug}/articles`,

  REGIONAL_EVENT_PATH: (city_slug = ':city_slug', id = ':id') => `/${city_slug}/events/${id}`,
  REGIONAL_EVENTS_PATH: (city_slug = ':city_slug') => `/${city_slug}/events`,

  REGIONAL_PAYMENTS_PATH: (city_slug = ':city_slug') => `/${city_slug}/payments`,

  REGIONAL_CALCULATORS_PATH: (city_slug = ':city_slug', id = ":id") => `/${city_slug}/calculators/${id}`,

  HOME: '/',
  NOT_FOUND: '/404',
  BRANDS_PATH: '/brands',
  CONTACTS_PATH: '/contacts',
  STOCKS_PATH: '/stocks',
  EVENTS_PATH: '/events',
  ARTICLES_PATH: '/articles',
  USER_DASHBOARD: '/dashboard',
  REMOTE_PAY_PATH: '/remote-pay',
  PERSONAL_DATA_PAGE_PATH: '/personal_data_processing_policy',
  REVIEWS_PATH: '/reviews',
  PARTNERS_PATH: '/partners',
  NEW_REVIEW_PATH: '/reviews/new',
  COMPARISON_PAGE_PATH: '/product_comparison',
  CALCULATOR_SFTK_PATH: '/calculator-sftk',
  CART: '/cart',
  CART_SUCCESS_PAYMENT_PATH: '/cart/payment_success',
  ORDER_PATH: '/cart/order',
  SEARCH_PATH: '/search',

  SESSION_LOGIN: '/session/login',
  SESSION_LOGOUT: '/session/logout',

  USER: '/user',
  CHANGE_PASSWORD: '/change-password',
  PASSWORD_RECOVERY: '/password-recovery',

  SHOP_UNAVAILABLE: '/maintenance',
};
